export default "__VITE_ASSET__DZkGG3eg__"